module.exports = __webpack_public_path__ + "img/google-play.14b85386.png";